export enum Roles {
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  LOCAL_ADMIN = 'LOCAL_ADMIN',
  INSPECTOR = 'INSPECTOR',
  MANAGER = 'MANAGER',
  COMMUNITY_CUSTOMER = 'COMMUNITY_CUSTOMER',
  PROPERTY_CUSTOMER = 'PROPERTY_CUSTOMER',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
